var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotel-building-room-view"},[_c('hotel-building-room-form',{attrs:{"building-id":_vm.buildingId,"hotel-id":_vm.hotelId,"room-id":_vm.roomId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }